/**
 * Generated from ch5_p16.fla
 */
export function ch5_p16(this: Ich5_p16) {
	const balloons = this.balloons;
	if (!balloons[0] && balloons.elementFactory) {
		balloons[0] = balloons.elementFactory(0,undefined);
	}
	if (balloons[0]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p16_balloons.call(balloons[0] as Ich5_p16_hh_ch5_p01617psdAssetch5_p16_balloons);
		balloons[0].x = 925.75;
		balloons[0].y = 172.5;
		balloons[0].width = 369.50;
		balloons[0].height = 278.00;
		balloons[0].alpha = 1;
		if (balloons[0].onLayout) balloons[0].onLayout();
	}
	if (!balloons[1] && balloons.elementFactory) {
		balloons[1] = balloons.elementFactory(1,undefined);
	}
	if (balloons[1]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p17_balloons.call(balloons[1] as Ich5_p16_hh_ch5_p01617psdAssetch5_p17_balloons);
		balloons[1].x = 1030.25;
		balloons[1].y = 60.25;
		balloons[1].width = 177.50;
		balloons[1].height = 120.50;
		balloons[1].alpha = 1;
		if (balloons[1].onLayout) balloons[1].onLayout();
	}
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p16_holly.call(holly[0] as Ich5_p16_hh_ch5_p01617psdAssetch5_p16_holly);
		holly[0].x = 703.75;
		holly[0].y = 481.75;
		holly[0].width = 212.50;
		holly[0].height = 572.50;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p17_holly.call(holly[1] as Ich5_p16_hh_ch5_p01617psdAssetch5_p17_holly);
		holly[1].x = 692;
		holly[1].y = 480.25;
		holly[1].width = 182.00;
		holly[1].height = 575.50;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const tyler = this.tyler;
	if (!tyler[0] && tyler.elementFactory) {
		tyler[0] = tyler.elementFactory(0,undefined);
	}
	if (tyler[0]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p16_tyler.call(tyler[0] as Ich5_p16_hh_ch5_p01617psdAssetch5_p16_tyler);
		tyler[0].x = 992.5;
		tyler[0].y = 447.5;
		tyler[0].width = 167.00;
		tyler[0].height = 641.00;
		tyler[0].alpha = 1;
		if (tyler[0].onLayout) tyler[0].onLayout();
	}
	if (!tyler[1] && tyler.elementFactory) {
		tyler[1] = tyler.elementFactory(1,undefined);
	}
	if (tyler[1]) {
		ch5_p16_hh_ch5_p01617psdAssetch5_p17_tyler.call(tyler[1] as Ich5_p16_hh_ch5_p01617psdAssetch5_p17_tyler);
		tyler[1].x = 1006;
		tyler[1].y = 445.5;
		tyler[1].width = 172.00;
		tyler[1].height = 645.00;
		tyler[1].alpha = 1;
		if (tyler[1].onLayout) tyler[1].onLayout();
	}
	const bg = this.bg;
	ch5_p16_hh_ch5_p01617psdAssetch5_p16_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const rainoverlay = this.rainoverlay;
	ch5_p16_hh_ch5_p01617psdAssetch5_p17_rainoverlay.call(this.rainoverlay);
	rainoverlay.x = 832;
	rainoverlay.y = 384;
	rainoverlay.width = 1664.00;
	rainoverlay.height = 768.00;
	rainoverlay.alpha = 1.00;
	if (rainoverlay.onLayout) rainoverlay.onLayout();
	const rain = this.rain;
	ch5_p16_hh_ch5_p01617psdAssetRainMockup.call(this.rain);
	rain.x = 822.75;
	rain.y = 384;
	rain.width = 1498.50;
	rain.height = 768.00;
	rain.alpha = 1.00;
	if (rain.onLayout) rain.onLayout();
	const frameRight = this.frameRight;
	ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 432.5;
	linesRight.width = 77.50;
	linesRight.height = 303.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLayer248.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 512.75;
	linesLeft.width = 162.50;
	linesLeft.height = 185.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_bg(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p16_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_balloons(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_balloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p16_balloons", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p17_balloons(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p17_balloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p17_balloons", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_holly(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p16_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_tyler(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p16_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p17_holly(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p17_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p17_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p17_tyler(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p17_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p17_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p17_rainoverlay(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p17_rainoverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p17_rainoverlay", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetRainMockup(this: Ich5_p16_hh_ch5_p01617psdAssetRainMockup) {
	if (this.setLayoutTexture) this.setLayoutTexture("RainMockup", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeRframe(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframerlines(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLframe(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLayer248(this: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLayer248) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer248", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p16Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p16Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p16Sprite extends Ich5_p16Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p16Text extends Ich5_p16Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p16Polygon extends Array<number> {
}
interface Ich5_p16 {
	readonly balloons: Ich5_p16Array<Ich5_p16_hh_ch5_p01617psdAssetch5_p16_balloons|Ich5_p16_hh_ch5_p01617psdAssetch5_p17_balloons>;
	readonly holly: Ich5_p16Array<Ich5_p16_hh_ch5_p01617psdAssetch5_p16_holly|Ich5_p16_hh_ch5_p01617psdAssetch5_p17_holly>;
	readonly tyler: Ich5_p16Array<Ich5_p16_hh_ch5_p01617psdAssetch5_p16_tyler|Ich5_p16_hh_ch5_p01617psdAssetch5_p17_tyler>;
	readonly bg: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_bg;
	readonly rainoverlay: Ich5_p16_hh_ch5_p01617psdAssetch5_p17_rainoverlay;
	readonly rain: Ich5_p16_hh_ch5_p01617psdAssetRainMockup;
	readonly frameRight: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeRframe;
	readonly linesRight: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframerlines;
	readonly frameLeft: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLframe;
	readonly linesLeft: Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLayer248;
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_bg extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_balloons extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p17_balloons extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_holly extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_tyler extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p17_holly extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p17_tyler extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p17_rainoverlay extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetRainMockup extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeRframe extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframerlines extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLframe extends Ich5_p16Sprite {
}
interface Ich5_p16_hh_ch5_p01617psdAssetch5_p16_wcframeLayer248 extends Ich5_p16Sprite {
}
